import type { AllRouteEndpoints } from "../routeTypes";
export const generativeAiBrandGuidelineUpdateArchivedStateCacheKeys: AllRouteEndpoints[] = [
  "/generative_ai/list_brand_guidelines",
];
